import { render, staticRenderFns } from "./QuizTeacherAcademicProfile.vue?vue&type=template&id=dec8ef2a&"
import script from "./QuizTeacherAcademicProfile.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherAcademicProfile.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherAcademicProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports